module.exports = __webpack_public_path__ + "static/media/pay.86abac29.svg";